import pluralize from 'pluralize'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { normalize, stringifyDate, usePet } from '../../modules'

import Modal from "../resusable/modal"
import Receive from '../resusable/receive'

const SalesReport = ({ toggle, visible, ranges, selectCategory }) => {
    const [categories, setCategories] = useState([])

    const [{ loading, error }, salesByCategory] = usePet('salesByCategory',
        ranges ? 
            { 
                from: ranges[0]?._d ?? null, 
                to: ranges[1]?._d ?? null 
            }
        : {}
    , { notify: true, callback: ({ data }) => setCategories(data) })

    const changeCategory = category => {
        let cat = { label: category, value: category }

        if (category === 'All')
            cat.label = 'All Categories'
        
        selectCategory(cat)
        toggle()
    }
    
    return (
        <Modal
            h="h-auto"
            w="w-3/5"
            align="items-start"
            top="mt-10"
            bottom="pb-10"
            title="Sales By Item Category"
            toggle={toggle}
            visible={visible}>
            <Receive
                error={error}
                loading={loading}
                progress>
                <>
                    <p className="text-lg font-bold">Sales { String(ranges[0]) === String(ranges[1]) ? `For ${stringifyDate(ranges[0]?._d.toUTCString(), true)}` : `From ${stringifyDate(ranges[0]?._d, true)} To ${stringifyDate(ranges[1]?._d, true)}` }</p>
                    <div className="grid grid-cols-12 gap-6 mb-5">
                        <div onClick={ () => changeCategory('All') } className="cursor-pointer flex flex-col p-4 rounded-sm col-span-full sm:col-span-6 xl:col-span-4 bg-white shadow-lg border border-gray-200">
                            <div>
                                <h2 className="text-lg font-semibold text-gray-800 mb-2">Total Sales</h2>
                                <div className="text-xs font-semibold text-gray-400 uppercase mb-1">Ksh. { normalize(categories.reduce((total, cat) => total + cat.discount, 0)) } discounts</div>
                                <div className="text-xs font-semibold text-gray-400 uppercase mb-1">Ksh. { normalize(categories.reduce((total, cat) => total + (cat.sales - cat.discount), 0)) } gross sales</div>
                                <div className="text-xs font-semibold text-gray-400 uppercase mb-1">Ksh. { normalize(categories.reduce((total, cat) => total + cat.tax, 0)) } - taxes</div>
                                <div className="flex items-start">
                                <div className="text-2xl font-bold text-gray-800 mr-2">Ksh. { normalize(categories.reduce((total, cat) => total + (cat.sales - cat.discount), 0)) }</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className="text-lg font-bold">Sales By Item Category</p>
                    <div className="grid grid-cols-12 gap-6 mb-5">
                        {
                            categories.map(category =>
                                <div onClick={ () => changeCategory(category.name) } className="cursor-pointer flex flex-col p-4 col-span-full sm:col-span-6 xl:col-span-4 bg-white shadow-lg rounded-sm border border-gray-200">
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-800 mb-2">{ category.name }</h2>
                                        <div className="text-xs font-semibold text-gray-400 uppercase mb-1">{ category.count } { pluralize(category.name, category.count) } sold</div>
                                        <div className="flex items-start">
                                        <div className="text-2xl font-bold text-gray-800 mr-2">Ksh. { normalize(category.sales - category.discount) }</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </>
            </Receive>
            <div className="flex justify-end">
                <button type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Print</button>
            </div>
        </Modal>
    )
}

export default SalesReport